import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Button from 'components/button'

import styles from './cropper-tool.css'

const CropperTool = ({ children, onCancel, onSave }) => (
  <div styleName="cropper-tool">
    <ul styleName="header">
      <li styleName="header_item">
        <Button text="Cancel" type="cropper" onClick={onCancel} />
      </li>
      <li styleName="header_item">
        <Button text="Save" type="cropper" onClick={onSave} />
      </li>
    </ul>
    {children}
  </div>
)

CropperTool.propTypes = {
  children: PropTypes.any,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
}

export default CSSModules(CropperTool, styles)



/** WEBPACK FOOTER **
 ** ./src/components/cropper-tool/cropper-tool.js
 **/